import type { Transition } from 'motion/react';

// 무한 캐러셀(윈도잉): active 는 무한 정수. 좌우로 넉넉히(±WINDOW) 미리 렌더해두고
// 화면 밖 카드는 clip 으로 잘리기만 한다. fade 없이 '밀어서' 슬라이드 → 재중심화·페이드
// 관련 튐이 전혀 없다.
export const WINDOW = 5;

// 부채꼴 배치: 카드가 큰 원의 위쪽 호(dome)에 놓인 것처럼 배치.
// 중앙은 최상단(y=0), 바깥으로 갈수록 원을 따라 아래로 내려가며 회전한다.
export const FAN_RADIUS = 2685; // 데스크탑(카드 360)
export const FAN_ANGLE = 9; // 데스크탑 카드당 각도(도)
export const FAN_RADIUS_MOBILE = 2693; // 모바일(카드 280)
export const FAN_ANGLE_MOBILE = 7;

// 중앙에서 이 칸수 이내의 카드만 상호작용(마우스·키보드 포커스) 가능.
// 나머지(화면 밖으로 회전·클립된 카드)는 inert 로 탭 순서·스크린리더·포인터에서 제외한다.
export const INTERACTIVE_OFFSET = 2; // 데스크탑
export const INTERACTIVE_OFFSET_MOBILE = 1; // 모바일

// 슬라이드(부채꼴 이동)·플립 트랜지션 — 두 캐러셀/카드가 공유
export const SLIDE_TRANSITION: Transition = {
  type: 'spring',
  stiffness: 260,
  damping: 32,
};
// 앞면 → 뒷면(장점 노출) 플립
export const FLIP_TRANSITION: Transition = {
  duration: 0.7,
  ease: [0.4, 0, 0.2, 1],
};
// 뒷면 → 앞면(질문 복귀) 플립: 복귀는 더 천천히 뒤집히도록 duration 상향
export const FLIP_RETURN_TRANSITION: Transition = {
  duration: 1.0,
  ease: [0.4, 0, 0.2, 1],
};

// 캐러셀 이동 gtag 라벨 (버튼·키보드·스와이프 공용, method 로 입력 방식 구분)
export const carouselNavLabel = (direction: 'prev' | 'next') =>
  `solution-finder_carousel_${direction}`;
